import { useField } from 'formik'
import { Ref, useCallback } from 'react'
import { Input as AntdInput, InputRef as AntdInputRef } from '../../Input'
import type { SearchProps as AntdSearchProps } from '../../Input'
import type { FormikFieldProps } from '../typings/FieldProps'

export type SearchProps = FormikFieldProps &
  AntdSearchProps & {
    ref?: Ref<AntdInputRef>
  }

export const Search = ({
  name,
  onChange: onChangeProp,
  onBlur: onBlurProp,
  ...restProps
}: SearchProps) => {
  const [field] = useField(name)
  const { value, onChange, onBlur } = field

  const handleChange = useCallback(
    (event: any) => {
      onChange(event)
      onChangeProp?.(event)
    },
    [onChange, onChangeProp]
  )

  const handleBlur = useCallback(
    (event: any) => {
      onBlur(event)
      onBlurProp?.(event)
    },
    [onBlur, onBlurProp]
  )

  return (
    <AntdInput.Search
      name={name}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      {...restProps}
    />
  )
}
